var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon blueSVGs",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0008 18.8341C5.39844 18.8341 1.66748 15.1031 1.66748 10.5008C1.66748 5.89844 5.39844 2.16748 10.0008 2.16748C14.6031 2.16748 18.3341 5.89844 18.3341 10.5008C18.3341 15.1031 14.6031 18.8341 10.0008 18.8341ZM10.0008 17.1675C13.6827 17.1675 16.6675 14.1827 16.6675 10.5008C16.6675 6.81891 13.6827 3.83415 10.0008 3.83415C6.31891 3.83415 3.33415 6.81891 3.33415 10.5008C3.33415 14.1827 6.31891 17.1675 10.0008 17.1675ZM9.16748 6.33415H10.8341V8.00081H9.16748V6.33415ZM9.16748 9.66748H10.8341V14.6675H9.16748V12.1675V9.66748Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.326116ad32b4d1df9913fb170f598c77.svg";
export { ForwardRef as ReactComponent };